import { endpoint } from 'services/endpoint';
import { backendHttp } from './backendHttp';
import { backendTokenClient } from './backendTokenClient';
import { USE_KEYCLOAK } from './config';
import { keycloakTokenClient } from './keycloakTokenClient';
import { normalizeTokenResponse } from './tokenResponse';
import { TAuthTokens, TRawTokenResponse, TTokenClient } from './types';

// Neman has no Keycloak: it signs in against the API with a password and refreshes there too.
export const tokenClient: TTokenClient = USE_KEYCLOAK ? keycloakTokenClient : backendTokenClient;

export const requestPasswordLogin = (
	login: string,
	password: string,
): Promise<TAuthTokens | null> =>
	backendHttp
		.post<TRawTokenResponse>(endpoint.auth.ACCOUNT_LOGIN, { login, password })
		.then((response) => normalizeTokenResponse(response.data));

export const notifyBackendOfLogout = (
	refreshToken: string,
	accessToken: string | null,
): Promise<unknown> =>
	backendHttp.post(endpoint.auth.LOGOUT, null, {
		params: { refreshToken },
		headers: accessToken ? { Authorization: accessToken } : undefined,
	});
